import { apiRequest, ApiResponse } from '../request'
import { getClient } from '../client'
import { downloadBlob } from '../../download-blob'

export type StoreNewsletterStatus = 'SUBSCRIBED' | 'UNSUBSCRIBED'

/** Inscrito da newsletter (ver `StoreNewsletterService` no backend). */
export interface StoreNewsletterSubscriber {
    id: number
    storeConfigId: number
    email: string
    status: StoreNewsletterStatus
    consentText: string
    consentAt: string
    consentIp: string | null
    consentUserAgent: string | null
    unsubscribedAt: string | null
    createdAt: string
}

export interface StoreNewsletterStore {
    id: number
    name: string
    subdomain: string
}

export async function listNewsletterStores(): Promise<ApiResponse<StoreNewsletterStore[]>> {
    return apiRequest('store-newsletter/stores', {})
}

export async function getNewsletterSummary(storeConfigId: number): Promise<ApiResponse<{ subscribed: number; unsubscribed: number }>> {
    return apiRequest(`store-newsletter/store/${storeConfigId}/summary`, {})
}

export async function listNewsletterSubscribers(
    storeConfigId: number,
    params: { page: number; limit: number; search?: string; status?: StoreNewsletterStatus },
): Promise<ApiResponse<StoreNewsletterSubscriber[]>> {
    return apiRequest(`store-newsletter/store/${storeConfigId}/subscribers`, { params })
}

export async function unsubscribeNewsletterSubscriber(storeConfigId: number, id: number): Promise<ApiResponse<void>> {
    return apiRequest(`store-newsletter/store/${storeConfigId}/subscribers/${id}/unsubscribe`, {}, 'post')
}

export async function removeNewsletterSubscriber(storeConfigId: number, id: number): Promise<ApiResponse<void>> {
    return apiRequest(`store-newsletter/store/${storeConfigId}/subscribers/${id}`, {}, 'delete')
}

/** Baixa a planilha dos inscritos (CSV com o link de descadastro de cada um). */
export async function exportNewsletterSubscribers(storeConfigId: number, fileName: string): Promise<void> {
    const response = await getClient().get(`store-newsletter/store/${storeConfigId}/export`, { responseType: 'blob' })
    downloadBlob(response.data, fileName)
}

export type StoreNewsletterFrequency = 'OFF' | 'WEEKLY' | 'BIWEEKLY' | 'MONTHLY'

export interface StoreNewsletterSettings {
    frequency: StoreNewsletterFrequency
    lastSentAt: string | null
    lastRunAt: string | null
}

export interface StoreNewsletterSend {
    id: number
    sentAt: string
    recipients: number
    failed: number
    products: number
    promotions: number
}

export async function getNewsletterSettings(storeConfigId: number): Promise<ApiResponse<StoreNewsletterSettings>> {
    return apiRequest(`store-newsletter/store/${storeConfigId}/settings`, {})
}

export async function updateNewsletterSettings(
    storeConfigId: number,
    frequency: StoreNewsletterFrequency,
): Promise<ApiResponse<StoreNewsletterSettings>> {
    return apiRequest(`store-newsletter/store/${storeConfigId}/settings`, { data: { frequency } }, 'put')
}

export async function listNewsletterSends(storeConfigId: number): Promise<ApiResponse<StoreNewsletterSend[]>> {
    return apiRequest(`store-newsletter/store/${storeConfigId}/sends`, {})
}

/** Manda a newsletter de teste para o e-mail de quem está no painel. */
export async function sendNewsletterTest(storeConfigId: number): Promise<ApiResponse<{ sentTo: string }>> {
    return apiRequest(`store-newsletter/store/${storeConfigId}/test-send`, {}, 'post')
}
